import React, { useState } from 'react';
import Collapsible from 'react-collapsible';
import './Article.css';

const baseURL = "https://warehouse-picker-proxy.qustom.workers.dev/proxy";

const Article = ({ article, pickedArticles, setPickedArticles, conneoId, batchId, globalAvailableStock, setGlobalAvailableStock }) => {
  // Helper function to generate unique key per order line
  const getArticleKey = () => `${article.id}_${article.orderNumber}`;

  const [locationQuantities, setLocationQuantities] = useState({});
  const [error, setError] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isandersLocationCollapsed, setIsandersLocationCollapsed] = useState(false);

  const [isEditCollapsed, setIsEditCollapsed] = useState(false);
  const [totalPickedQuantity, setTotalPickedQuantity] = useState(
    pickedArticles[getArticleKey()]?.mainQuantity || 0
  );
  const [andersQuantity, setAndersQuantity] = useState('');
  const [editQuantity, setEditQuantity] = useState('');
  const [editAltQuantity, setEditAltQuantity] = useState('');
  const [loading, setLoading] = useState(false);
  const [showStockWarningModal, setShowStockWarningModal] = useState(false);
  const [stockWarningMessage, setStockWarningMessage] = useState({ requested: 0, server: 0 });
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState('');
  //const [andersSelected , setAndersSelected] = useState(false)
  const [mainSelected , setMainSelected] = useState(false)
  const [collapsedLocation, setCollapsedLocation] = useState({});
  const [collapsedLocationEdit, setCollapsedLocationEdit] = useState({});
  const [disabledButtons, setDisabledButtons] = useState({}); // Track disabled state of buttons
  const [displayQuantities, setDisplayQuantities] = useState({});
  const [isCorrectieCollapsed, setIsCorrectieCollapsed] = useState(false);
  const [correctieQuantity, setCorrectieQuantity] = useState('');
  const [collapsedLocationCorrectie, setCollapsedLocationCorrectie] = useState({});
  const [correctieAltQuantity, setCorrectieAltQuantity] = useState('');
  const [correctieSaved, setCorrectiesaved] = useState(null);
  const [correctieSavedLocations, setCorrectiesavedLocations] = useState({});
  const [buttonCaption, setButtonCaption] = useState(
    article.available < article.qty ? article.available : article.qty
  );
 // const [andersUsed, setAndersUsed] = useState({}); // Track whether Anders has been used for a location

  // Function to calculate the remaining quantity to be picked
  const calculateRemainingQuantity = () => {
    return Math.max(0, article.qty - totalPickedQuantity);
  };

  // Calculate total available stock across all locations
  const getTotalAvailableStock = () => {
    // Main location stock
    const mainKey = `${article.paperid}_${article.locationId}`;
    const mainStock = globalAvailableStock[mainKey] ?? article.available;

    // Alternative locations stock
    let alternativeStock = 0;
    if (article.locations && article.locations.length > 0) {
      alternativeStock = article.locations.reduce((total, location) => {
        const altKey = `${article.paperid}_${location.locationId}`;
        const stock = globalAvailableStock[altKey] ?? location.available;
        return total + stock;
      }, 0);
    }

    return mainStock + alternativeStock;
  };

  // Check if there's insufficient stock from the start
  const hasInsufficientStock = () => {
    const totalAvailable = getTotalAvailableStock();
    const remainingQty = calculateRemainingQuantity();
    return remainingQty > totalAvailable;
  };

  // Calculate the actual button caption dynamically based on global stock
  const getMainButtonCaption = () => {
    if (mainSelected) return 0;
    const remainingQty = article.qty - totalPickedQuantity;
    const mainKey = `${article.paperid}_${article.locationId}`;
    const availableStock = globalAvailableStock[mainKey] ?? article.available;
    return Math.min(remainingQty, availableStock);
  };

  const handlePickDefaultQuantity = () => {
    const mainKey = `${article.paperid}_${article.locationId}`;
    const currentGlobalStock = globalAvailableStock[mainKey] ?? article.available;
    if (currentGlobalStock === 0) {
      setError('There is not enough stock available.');
      return;
    }

    const remainingQuantity = calculateRemainingQuantity();
    // Calculate the actual amount we can pick based on global stock and remaining quantity
    const actualAvailable = Math.min(remainingQuantity, currentGlobalStock, article.qty - totalPickedQuantity);

    if (actualAvailable === 0) {
      setError('There is not enough stock available.');
      return;
    }

    const mainQuantity = actualAvailable;
    const totalAlternativeQuantity = Object.values(locationQuantities).reduce(
      (acc, qty) => acc + qty,
      0
    );
    const currentPickedQuantity = pickedArticles[getArticleKey()]?.mainQuantity || 0;
    const totalQuantity = mainQuantity + totalAlternativeQuantity + currentPickedQuantity;
    // console.log("total alternative quantity: " , remainingQuantity);
    console.log("main quantity: " , mainQuantity , currentPickedQuantity , totalQuantity);

    // console.log("from the main one: " , totalAlternativeQuantity)
    // if (totalQuantity > article.qty) {
    //   setError(`The total picked quantity (${totalQuantity}) exceeds the ordered quantity (${article.qty}).`);
    //   return;
    // }

    setButtonCaption(0);

    const updatedPickedArticles = {
      ...pickedArticles,
      [getArticleKey()]: {
        mainQuantity: mainQuantity + currentPickedQuantity,
        locations: locationQuantities,
      },
    };

    setPickedArticles(updatedPickedArticles);
    //console.log("PP default: " , JSON.stringify(pickedArticles))
    setTotalPickedQuantity(totalPickedQuantity + mainQuantity);

    // Update global available stock for the main location
    setGlobalAvailableStock((prev) => ({
      ...prev,
      [mainKey]: Math.max(0, (prev[mainKey] || 0) - mainQuantity),
    }));

    setError('');
    setMainSelected(true);
    // Disable the green button if "Anders" was used
    setDisabledButtons((prev) => ({
      ...prev,
      [article.locationId]: true, // Disable the green button
    }));

  };

  const handleAddAndersQuantity = () => {
    if (article.available === 0) {
      setError('There is not enough stock available.');
      return;
    }

    const mainQuantity = Number(andersQuantity);
    const totalAlternativeQuantity = Object.values(locationQuantities).reduce((acc, qty) => acc + qty, 0);
    const currentPickedQuantity = pickedArticles[getArticleKey()]?.mainQuantity || 0;
    const totalQuantity = mainQuantity + totalAlternativeQuantity + currentPickedQuantity;

    const maxExpectedQty = article.available > article.qty ? article.qty : article.available;

    if (totalAlternativeQuantity > totalQuantity || article.available < totalQuantity) {
      setError('Exceeded the maximum available quantity!');
      return;
    }
    if (isNaN(mainQuantity) || mainQuantity <= 0 || totalQuantity > article.qty || mainQuantity > maxExpectedQty) {
      setError(`Please enter a valid quantity greater than 0 and ensure the total does not exceed the ordered quantity (${article.qty}).`);
      return;
    }

    //console.log("From main article:" , totalAlternativeQuantity , buttonCaption , mainQuantity ,  totalPickedQuantity + mainQuantity);
    const updatedButtonCaption = Math.max(0, buttonCaption - mainQuantity); // Ensure it doesn't go negative

    if (updatedButtonCaption < 0) {
      setError('The quantity entered exceeds the available stock.');
      return;
    }

    setButtonCaption(updatedButtonCaption);
    const updatedTotalPickedQuantity = totalPickedQuantity + mainQuantity;

    const updatedPickedArticles = {
      ...pickedArticles,
      [getArticleKey()]: {
        mainQuantity: currentPickedQuantity + mainQuantity,
        locations: locationQuantities,
      },
    };

    setPickedArticles(updatedPickedArticles);
    // console.log("PP andres: " , JSON.stringify(pickedArticles))
    setTotalPickedQuantity(updatedTotalPickedQuantity);

    // Update global available stock for the main location
    const mainKey = `${article.paperid}_${article.locationId}`;
    setGlobalAvailableStock((prev) => ({
      ...prev,
      [mainKey]: Math.max(0, (prev[mainKey] || 0) - mainQuantity),
    }));

    setAndersQuantity('');
    setError('');
    //setAndersSelected(true);
  };

  const handleLocationQuantityChange = (locationId, value, availableForLocation) => {
    const inputQuantity = Math.max(0, Number(value)); // Ensure no negative values
    // Check if the input quantity exceeds the available quantity
    if (inputQuantity > availableForLocation) {
      setError(`You cannot pick more than the available quantity for this location.`);
      return;
    }

    setLocationQuantities({
      ...locationQuantities,
      [locationId]: inputQuantity,
    });

    // Mark "Anders" as used if the user enters a value
    // setAndersUsed((prev) => ({
    //   ...prev,
    //   [locationId]: true,
    // }));
  };

  const handleMainQuantityChange = (value) => {
    const inputQuantity = Math.max(0, Number(value)); // Ensure no negative values
    // Check if the input quantity exceeds the available quantity
    if (inputQuantity > article.available) {
      setError(`You cannot pick more than the available quantity for this location.`);
      return;
    }
    setAndersQuantity(value);
  };

  const handlePickDefaultQuantityLocation = (location) => {
    const altKey = `${article.paperid}_${location.locationId}`;
    const availableStock = globalAvailableStock[altKey] || 0;
    if (availableStock === 0) {
      setError('There is not enough stock available.');
      return;
    }
    if(Number(availableStock) > Number(location.available))
    {
      setError('Te weinig voorraad!');
      return;
    }

    const remainingQuantity = calculateRemainingQuantity();
    const currentPickedQuantity = pickedArticles[location.locationId]?.mainQuantity || 0;

    let pickedQuantity = Math.min(availableStock, remainingQuantity);
    // console.log("from sub : ", pickedQuantity , currentPickedQuantity)
    pickedQuantity += currentPickedQuantity;

    const totalAlternativeQuantity = pickedQuantity + currentPickedQuantity + Object.values(locationQuantities).reduce((acc, qty) => acc + qty, 0);

    if (totalAlternativeQuantity > article.qty) {
      setError(`The total picked quantity exceeds the ordered quantity (${article.qty}).`);
      return;
    }

    // console.log("from sub default" , totalPickedQuantity ,pickedQuantity)
    setTotalPickedQuantity(Math.min(totalPickedQuantity + pickedQuantity , article.qty));
      // Update picked quantities for the location
    setLocationQuantities((prev) => ({
      ...prev,
      [location.locationId]: pickedQuantity,
    }));

    setPickedArticles((prevPickedArticles) => ({
      ...prevPickedArticles,
      [getArticleKey()]: {
        ...prevPickedArticles[getArticleKey()],
        locations: {
          ...prevPickedArticles[getArticleKey()]?.locations,
          [location.locationId]: (prevPickedArticles[getArticleKey()]?.locations[location.locationId] || 0) + Number(pickedQuantity)
        },
        },
    }));

    //console.log("from sub set picked quantity: " , location.locationId , JSON.stringify(pickedArticles));
    // Update available stock for the location - GLOBALLY
    setGlobalAvailableStock((prev) => ({
      ...prev,
      [altKey]: Math.max(0, prev[altKey] - pickedQuantity),
    }));

    // Disable the green button after clicking
    setDisabledButtons((prev) => ({
      ...prev,
      [location.locationId]: true, // Mark this location button as disabled
    }));

    // **Update the buttonCaption based on the remaining quantity to pick**
    //.log(currentPickedQuantity , article.qty ,totalAlternativeQuantity, pickedQuantity , totalPickedQuantity, remainingQuantity);
    const updatedButtonCaption = Math.max(0 , article.qty-(totalPickedQuantity + pickedQuantity));
    const mainKey = `${article.paperid}_${article.locationId}`;
    setButtonCaption(Math.min(updatedButtonCaption, globalAvailableStock[mainKey] ?? article.available)); // Ensure it reflects the correct remaining quantity
   // console.log("updated button caption" , updatedButtonCaption);
    setError('');
  };
  
  const handleAddAndersQuantityLocation = (location) => {
    const altKey = `${article.paperid}_${location.locationId}`;
    const availableStock = globalAvailableStock[altKey] || 0;
    if (availableStock === 0) {
      setError('There is not enough stock available.');
      return;
    }

    const pickedQuantity = Math.min(Number(locationQuantities[location.locationId]), availableStock);
    const remainingQuantity = calculateRemainingQuantity();

    if (pickedQuantity > Math.min(remainingQuantity, availableStock))
    {
      setError(`you cannot pick more than the available quantity`);
      return;
    }
    // Validate the picked quantity against the available stock and remaining quantity
    if (isNaN(pickedQuantity) || pickedQuantity <= 0) {
      setError(`Please enter a valid quantity and ensure it does not exceed the available quantity for this location.`);
      return;
    }

    setLocationQuantities((prev) => ({
      ...prev,
      [location.locationId]: pickedQuantity,
    }));

    const updatedTotalPickedQuantity = totalPickedQuantity + pickedQuantity;
   // console.log("NEHAL Before: " , JSON.stringify(pickedArticles));

    setPickedArticles((prevPickedArticles) => ({
      ...prevPickedArticles,
      [getArticleKey()]: {
        ...prevPickedArticles[getArticleKey()],
        locations: {
          ...prevPickedArticles[getArticleKey()]?.locations,
          [location.locationId]: ((prevPickedArticles[getArticleKey()]?.locations[location.locationId] || 0) + Number(pickedQuantity)),
        },
      },
    }));

    //console.log("NEHAL: " , location.locationId , pickedQuantity,  JSON.stringify(pickedArticles));

    // Update available stock for the location - GLOBALLY
    setGlobalAvailableStock((prev) => ({
      ...prev,
      [altKey]: Math.max(0, prev[altKey] - pickedQuantity),
    }));

    // Disable the green button if "Anders" was used
    // setDisabledButtons((prev) => ({
    //   ...prev,
    //   [location.locationId]: true, // Disable the green button
    // }));

    // Mark "Anders" as used
    // setAndersUsed((prev) => ({
    //   ...prev,
    //   [location.locationId]: true,
    // }));

    setTotalPickedQuantity(updatedTotalPickedQuantity);

    // **Update the buttonCaption based on the remaining quantity to pick**
    const updatedButtonCaption = Math.max(0 , article.qty-updatedTotalPickedQuantity);
   // console.log(updatedButtonCaption);
    const mainKey = `${article.paperid}_${article.locationId}`;
    setButtonCaption(Math.min(updatedButtonCaption, globalAvailableStock[mainKey] ?? article.available));
    //setButtonCaption(updatedButtonCaption);
    // setLocationQuantities({
    //   ...locationQuantities,
    //   [location.locationId]: 0,
    // });
    // After all your calculations, clear the display value
    setDisplayQuantities(prev => ({...prev, [location.locationId]: ''}));
    setError('');
  };
  
  const handleCollapsibleClick = () => {
    if(isEditCollapsed) setIsEditCollapsed(false);
    setIsCollapsed(!isCollapsed);
  };

  const handleEditCollapsibleClick = () => {
    setIsEditCollapsed(!isEditCollapsed);
    setIsCorrectieCollapsed(false);
    if(isCollapsed) setIsCollapsed(false);
    setCollapsedLocationEdit((prev) => {
      const updatedCollapsedState = {};
      Object.keys(prev).forEach((key) => {
        updatedCollapsedState[key] = false;
      });
        return updatedCollapsedState;
    });
  };

  const handleEditCollapsibleAltClick = (locationId) => {
    collapsedLocation[locationId] = false;
    setIsEditCollapsed(false);
    setCollapsedLocationCorrectie((prev) => ({ ...prev, [locationId]: false }));
    // setCollapsedLocationEdit((prev) => ({
    //   ...prev,
    //   [locationId]: !prev[locationId],
    // }));
    setCollapsedLocationEdit((prev) => {
      const updatedCollapsedState = {};
        // Loop through existing state and set all to false except the clicked location
      Object.keys(prev).forEach((key) => {
        updatedCollapsedState[key] = key === locationId ? !prev[key] : false;
      });

      // Ensure that the clicked location always exists in the updated state
      updatedCollapsedState[locationId] = !prev[locationId];
        return updatedCollapsedState;
    });
  };

  const handleEditMainQuantity = async () => {
      setLoading(true); // Start loader
      try {
        // DEBUG MODE: Skip API call if conneoId is "DEBUG"
        if (conneoId === "DEBUG") {
          console.log('DEBUG MODE: Skipping correctstock API call');

            const requestedStock = Number(editQuantity);
            const serverStock = requestedStock-10; // Simulate server adjusting the stock

            //throw new Error("Simulated error for testing error modal");

            // Warn user if server returned different stock than requested
            if (serverStock !== requestedStock) {
              setStockWarningMessage({ requested: requestedStock, server: serverStock });
              setShowStockWarningModal(true);
            }


          article.available = serverStock;
          setButtonCaption(Math.min(serverStock,(article.qty - totalPickedQuantity)))
          // Update global available stock for the main location
          const mainKey = `${article.paperid}_${article.locationId}`;
          setGlobalAvailableStock((prev) => ({
            ...prev,
            [mainKey]: serverStock
          }));
        } else {
          const payload = {
            articleId: article.paperid,
            code: '',
            articleType: 100,
            quantity: editQuantity,
            locationId: article.locationId,
            reason: "Correctie vanuit mobiele app",
          };
          const response = await fetch(`${baseURL}/${conneoId}/${batchId}/correctstock`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          const data = await response.json();
          if (!response.ok || data.meta.status !== 'success') throw new Error(data.meta.error);
          else
          {
            const serverStock = data.data.stock;
            const requestedStock = Number(editQuantity);

            // Warn user if server returned different stock than requested
            if (serverStock !== requestedStock) {
              setStockWarningMessage({ requested: requestedStock, server: serverStock });
              setShowStockWarningModal(true);
            }

            article.available = serverStock;
            setButtonCaption(Math.min(serverStock,(article.qty - totalPickedQuantity)))
            // Update global available stock for the main location
            const mainKey = `${article.paperid}_${article.locationId}`;
            setGlobalAvailableStock((prev) => ({
              ...prev,
              [mainKey]: serverStock
            }));
          }
        }

      } catch (error) {
        setErrorModalMessage(error.message);
        setShowErrorModal(true);
        console.error(error.message);
      } finally {
        setLoading(false); // Stop loader
      }

    setEditQuantity('');
    setIsEditCollapsed(false)
  };

  const handleEditAltQuantity = async (location) => {
      setLoading(true); // Start loader
      try {
        // DEBUG MODE: Skip API call if conneoId is "DEBUG"
        if (conneoId === "DEBUG") {
          console.log('DEBUG MODE: Skipping correctstock API call for alternative location');
          const newStock = Number(editAltQuantity);
          location.available = newStock;
          // Update global available stock for the alternative location
          const altKey = `${article.paperid}_${location.locationId}`;
          setGlobalAvailableStock((prev) => ({
            ...prev,
            [altKey]: newStock
          }));
        } else {
          const payload = {
            articleId: article.paperid,
            code: '',
            articleType: 100,
            quantity: editAltQuantity ,
            locationId: location.locationId,
          };


          const response = await fetch(`${baseURL}/${conneoId}/${batchId}/correctstock`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          const data = await response.json();
          if (!response.ok || data.meta.status !== 'success') throw new Error(data.meta.error);
          else
          {
            const serverStock = data.data.stock;
            const requestedStock = Number(editAltQuantity);

            // Warn user if server returned different stock than requested
            if (serverStock !== requestedStock) {
              setStockWarningMessage({ requested: requestedStock, server: serverStock });
              setShowStockWarningModal(true);
            }

            location.available = serverStock;
            // Update global available stock for the alternative location
            const altKey = `${article.paperid}_${location.locationId}`;
            setGlobalAvailableStock((prev) => ({
              ...prev,
              [altKey]: serverStock
            }));
          }
        }

      } catch (error) {
        setErrorModalMessage(error.message);
        setShowErrorModal(true);
        console.error(error.message);
      } finally {
        setLoading(false); // Stop loader
      }
    setEditAltQuantity(null);
    handleEditCollapsibleAltClick(location.locationId);
  };

  const toggleLocationCollapsible = (locationId) => {
    setCollapsedLocation((prev) => ({
      ...prev,
      [locationId]: !prev[locationId],
    }));
    collapsedLocationEdit[locationId] = false;
  };

  const handleCorrectieMainQuantity = async () => {
    setLoading(true);
    try {
      if (conneoId === "DEBUG") {
        console.log('DEBUG MODE: Skipping correctstock API call for correctie');
      } else {
        const payload = {
          articleId: article.paperid,
          code: '',
          articleType: 100,
          quantity: 0,
          difference: Number(correctieQuantity),
          locationId: article.locationId,
          reason: `Correctie ${article.orderNumber}`,
        };
        const response = await fetch(`${baseURL}/${conneoId}/${batchId}/correctstock`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!response.ok || data.meta.status !== 'success') throw new Error(data.meta.error);

        const mainKey = `${article.paperid}_${article.locationId}`;
        setGlobalAvailableStock((prev) => ({
          ...prev,
          [mainKey]: Math.max(0, (prev[mainKey] ?? article.available) - Number(correctieQuantity)),
        }));
        setCorrectiesaved(Number(correctieQuantity));
      }
    } catch (error) {
      setErrorModalMessage(error.message);
      setShowErrorModal(true);
      console.error(error.message);
    } finally {
      setLoading(false);
    }
    setCorrectieQuantity('');
    setIsCorrectieCollapsed(false);
  };

  const handleCorrectieAltQuantity = async (location) => {
    setLoading(true);
    try {
      if (conneoId === "DEBUG") {
        console.log('DEBUG MODE: Skipping correctstock API call for correctie alt location');
      } else {
        const payload = {
          articleId: article.paperid,
          code: '',
          articleType: 100,
          quantity: 0,
          difference: Number(correctieAltQuantity),
          locationId: location.locationId,
          reason: `Correctie ${article.orderNumber}`,
        };
        const response = await fetch(`${baseURL}/${conneoId}/${batchId}/correctstock`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!response.ok || data.meta.status !== 'success') throw new Error(data.meta.error);

        const altKey = `${article.paperid}_${location.locationId}`;
        setGlobalAvailableStock((prev) => ({
          ...prev,
          [altKey]: Math.max(0, (prev[altKey] ?? location.available) - Number(correctieAltQuantity)),
        }));
        setCorrectiesavedLocations((prev) => ({ ...prev, [location.locationId]: Number(correctieAltQuantity) }));
      }
    } catch (error) {
      setErrorModalMessage(error.message);
      setShowErrorModal(true);
      console.error(error.message);
    } finally {
      setLoading(false);
    }
    setCorrectieAltQuantity('');
    setCollapsedLocationCorrectie((prev) => ({ ...prev, [location.locationId]: false }));
  };

  const handleCorrectieCollapsibleClick = () => {
    setIsCorrectieCollapsed(!isCorrectieCollapsed);
    setIsEditCollapsed(false);
  };

  const toggleLocationCorrectie = (locationId) => {
    setCollapsedLocationCorrectie((prev) => ({
      ...prev,
      [locationId]: !prev[locationId],
    }));
    setCollapsedLocationEdit((prev) => ({ ...prev, [locationId]: false }));
  };

  const displayDescription = (article) => {
    const normalizedArticleCode = article.articleCode.replace(/[-_]/g, '');
    const normalizedDescription = article.description.replace(/[-_]/g, '');

    if (article.articleCode.includes(article.description))
      return `${article.orderNumber} - ${article.articleCode}`;

    const baseArticleCode = normalizedArticleCode.replace(/\d*$/, ''); // Remove any trailing digits
    return normalizedDescription.startsWith(baseArticleCode)
      ? article.orderNumber + ' - ' + article.description
      : `${article.orderNumber} - ${article.articleCode} - ${article.description}`;
  };

  return (
    <div className="article-card" style={{
      backgroundColor: totalPickedQuantity === 0 
        ? 'white' 
        : totalPickedQuantity === article.qty 
          ? '#95C3A7' 
          : '#FEF5B5'
    }}>
        {loading && (
        <div className="fullscreen-loader">
          <div className="spinner"></div>
        </div>
      )}
      <h3>{displayDescription(article)}</h3>
      <div className="article-details">
        <p>
          <strong>{article.location}</strong> ({article.warehouse}) [{globalAvailableStock[`${article.paperid}_${article.locationId}`] ?? article.available}]
        </p>
        <p><strong>Besteld: </strong> {article.qty}</p>
        <p>
          <strong>Gepakt: {totalPickedQuantity}</strong>
          {hasInsufficientStock() && (
            <span style={{ color: 'red', marginLeft: '10px', fontWeight: 'bold' }}>
              Te weinig voorraad
            </span>
          )}
        </p>
        <div className="button-group">
          {article.qty === 0 ? (
            <button
              onClick={handleCorrectieCollapsibleClick}
              className="btn-correctie"
            >
              {correctieSaved !== null ? `✔ ${correctieSaved}` : 'Correctie'}
            </button>
          ) : (
            <>
              <button onClick={handlePickDefaultQuantity} className="btn-default"
               disabled={getMainButtonCaption() === 0 || disabledButtons[article.locationId]}>
                {getMainButtonCaption()}
              </button>
              <button
                onClick={handleCollapsibleClick}
                className="btn-anders"
                disabled={getMainButtonCaption() === 0 || disabledButtons[article.locationId]}
              >
                Anders
              </button>
            </>
          )}
          {/* Edit Button */}
          <button
            onClick={handleEditCollapsibleClick}
            className="btn-edit"
          >
            <span className="edit-icon"> ✎</span>
          </button>
        </div>
        {isCollapsed && (
          <div className="anders-input-group">
            <input
              type="number"
              value={andersQuantity}
              onChange={(e) => handleMainQuantityChange(e.target.value)}
              placeholder="Aantal gepakt"
              className="input-quantity anders-input"
            />
            <button onClick={handleAddAndersQuantity} className="btn-check-mark">
              ✔
            </button>
          </div>
        )}

      {isEditCollapsed && (
          <div className="anders-input-group">
            <input
              type="number"
              min="0"
              value={editQuantity}
              onChange={(e) => {
                const value = e.target.value;
                // Only allow non-negative numbers
                if (value === '' || Number(value) >= 0) {
                  setEditQuantity(value);
                }
              }}
              placeholder="Aantal wijzigen"
              className="input-quantity anders-input"
              disabled={loading} // Disable input while loading
            />
            <button onClick={handleEditMainQuantity} className="btn-check-mark-edit" disabled={loading}>
            {loading ? 'Processing...' : '✔'}
            </button>
          </div>
        )}

      {isCorrectieCollapsed && (
          <div className="anders-input-group">
            <input
              type="number"
              value={correctieQuantity}
              onChange={(e) => setCorrectieQuantity(e.target.value)}
              placeholder="correctie aantal"
              className="input-quantity anders-input"
              disabled={loading}
            />
            <button onClick={handleCorrectieMainQuantity} className="btn-check-mark" disabled={loading}>
              {loading ? 'Processing...' : '✔'}
            </button>
          </div>
        )}
      </div>

      {article.locations && article.locations.length > 0 && (
        <Collapsible
          trigger={<div className={`collapsible-trigger ${isandersLocationCollapsed ? '' : 'active'}`}>Andere locaties</div>}
          open={isandersLocationCollapsed}
          className="collapsible"
          onClick={() => setIsandersLocationCollapsed(!isandersLocationCollapsed)}
        >
          {article.locations.map((location, index) => {
            const remainingQuantity = calculateRemainingQuantity();
            const altKey = `${article.paperid}_${location.locationId}`;
            const globalStock = globalAvailableStock[altKey] || 0;
            const availableForLocation = Math.max(0, Math.min(remainingQuantity, globalStock));
            const pickedForLocation = pickedArticles[getArticleKey()]?.locations?.[location.locationId] || 0;
            const isLocationFullyPicked = pickedForLocation >= availableForLocation;

            return (
              <div key={index} className="alternative-location">
                <p>
                  <strong>{location.location}</strong> ({location.warehouse}) [{globalStock}]
                  {pickedForLocation > 0 && <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>: {pickedForLocation}</span>}
                </p>
                <div className="button-group">
                  {article.qty === 0 ? (
                    <button
                      onClick={() => toggleLocationCorrectie(location.locationId)}
                      className="btn-correctie"
                    >
                      {correctieSavedLocations[location.locationId] !== undefined ? `✔ ${correctieSavedLocations[location.locationId]}` : 'Correctie'}
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={() => handlePickDefaultQuantityLocation(location)}
                        className="btn-default"
                        disabled={disabledButtons[location.locationId] || availableForLocation === 0}
                      >
                        {availableForLocation}
                      </button>
                      <button
                        onClick={() => toggleLocationCollapsible(location.locationId)}
                        className="btn-anders"
                        disabled={availableForLocation === 0 || isLocationFullyPicked || disabledButtons[location.locationId]}
                      >
                        Anders
                      </button>
                    </>
                  )}
                  <button
                    onClick={() => handleEditCollapsibleAltClick(location.locationId)}
                    className="btn-edit"
                  >
                    <span className="edit-icon"> ✎</span>
                  </button>
                </div>
                {collapsedLocation[location.locationId] && (
                  <div className="anders-input-group">
                    <input
                      type="number"
                      value={displayQuantities[location.locationId] || ''}
                      placeholder="Aantal gepakt"
                      className="input-quantity anders-input"
                      onChange={(e) => {
                        // Update both display and actual quantities
                        setDisplayQuantities(prev => ({...prev, [location.locationId]: e.target.value}));
                        handleLocationQuantityChange(location.locationId, e.target.value, availableForLocation);
                      }}
                    />
                    <button
                      onClick={() => handleAddAndersQuantityLocation(location)}
                      className="btn-check-mark"
                      disabled={Number(locationQuantities[location.locationId]) > availableForLocation} // Disable if input exceeds available
                    >
                      ✔
                    </button>
                  </div>
                )}
              {collapsedLocationEdit[location.locationId] && (
                   <div className="anders-input-group">
                   <input
                     type="number"
                     min="0"
                     value={editAltQuantity}
                     onChange={(e) => {
                       const value = e.target.value;
                       // Only allow non-negative numbers
                       if (value === '' || Number(value) >= 0) {
                         setEditAltQuantity(value);
                       }
                     }}
                     placeholder="Aantal wijzigen"
                     className="input-quantity anders-input"
                     disabled={loading}
                   />
                   <button onClick={() => handleEditAltQuantity(location)} className="btn-check-mark-edit" disabled={loading}>
                   {loading ? 'Processing...' : '✔'}
                   </button>
                 </div>
                )}
              {collapsedLocationCorrectie[location.locationId] && (
                <div className="anders-input-group">
                  <input
                    type="number"
                    value={correctieAltQuantity}
                    onChange={(e) => setCorrectieAltQuantity(e.target.value)}
                    placeholder="correctie aantal"
                    className="input-quantity anders-input"
                    disabled={loading}
                  />
                  <button onClick={() => handleCorrectieAltQuantity(location)} className="btn-check-mark" disabled={loading}>
                    {loading ? 'Processing...' : '✔'}
                  </button>
                </div>
              )}
              </div>
            );
          })}
        </Collapsible>
      )}
      {error && <p className="error-message">{error}</p>}

      {/* Stock Warning Modal */}
      {showStockWarningModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '10px',
            maxWidth: '400px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>⚠️</div>
            <h3 style={{ margin: '0 0 15px 0', color: '#333' }}>Afwijking</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Jij voerde in: <strong>{stockWarningMessage.requested}</strong><br />
              Server heeft opgeslagen: <strong>{stockWarningMessage.server}</strong><br />
              <br /><br />
              Server waarde wordt gebruikt!
            </p>
            <button
              onClick={() => setShowStockWarningModal(false)}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                backgroundColor: '#28a745',
                color: 'white',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Error Modal */}
      {showErrorModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '10px',
            maxWidth: '400px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>❌</div>
            <h3 style={{ margin: '0 0 15px 0', color: '#d32f2f' }}>Fout</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              {errorModalMessage}
            </p>
            <button
              onClick={() => setShowErrorModal(false)}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                backgroundColor: '#d32f2f',
                color: 'white',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              Sluiten
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Article;